import ClientLayout from '../../src/layouts/client/ClientLayout';
import { privatePolicy } from '../../src/components/MockData/MockData';
import MetaHeader from '../../src/components/MetaHeader';
import { textConfig } from '../../constants/textLang';

const contentFooter = (props) => {
    const { locale } = props;
    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <section className="content-footer">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{privatePolicy[locale].head_title}</h1>
                    </div>
                    <div className="main-content-text">
                        <div className="text">
                            <p>{privatePolicy[locale].top_title}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_one}</p>
                        </div>
                        <div className="text-topic-one">
                            <p className="text-detail">
                                {privatePolicy[locale].text_topic_one.title_one}
                            </p>
                            <div className="text">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_one
                                            .title_one_newline
                                    }
                                </p>
                            </div>
                            <div className="text">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_one
                                            .desc_one
                                    }
                                </p>
                            </div>
                            <div className="text">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_one
                                            .desc_two
                                    }
                                </p>
                            </div>
                        </div>
                        <div>
                            <div className="text">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_two
                                            .title_one
                                    }
                                </p>
                            </div>
                            <div className="text-detail">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_two
                                            .desc_one
                                    }
                                </p>
                            </div>
                            <div className="text">
                                <ul>
                                    {privatePolicy[
                                        locale
                                    ].text_topic_two.text_dot.map(
                                        (itemDot, indexDot) => (
                                            <li key={indexDot}>{itemDot}</li>
                                        )
                                    )}
                                </ul>
                            </div>
                            <div className="text">
                                <p>
                                    {
                                        privatePolicy[locale].text_topic_two
                                            .title_two_two
                                    }
                                </p>
                            </div>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_three}</p>
                        </div>
                        <div className="table-data-one">
                            <table className="table-one">
                                <thead>
                                    <tr>
                                        <th className="data-type">
                                            {
                                                privatePolicy[locale].text_table
                                                    .thead[0]
                                            }
                                        </th>
                                        <th className="detail">
                                            {
                                                privatePolicy[locale].text_table
                                                    .thead[1]
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {privatePolicy[locale].text_table.tbody.map(
                                        (itemTable, indexTable) => (
                                            <tr key={indexTable}>
                                                <td>{itemTable.data_type}</td>
                                                <td>{itemTable.desc}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_four}</p>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_detail_four}</p>
                        </div>
                        <div className="text-ul">
                            <ul>
                                {privatePolicy[locale].text_dot_four.map(
                                    (itemFour, indexFour) => (
                                        <li key={indexFour}>
                                            {itemFour.title}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_desc_four}</p>
                        </div>
                        <div className="table-data-four">
                            <table className="table-four">
                                <thead>
                                    <tr>
                                        <th className="data-type">
                                            {
                                                privatePolicy[locale]
                                                    .text_table_four
                                                    .text_head[0]
                                            }
                                        </th>
                                        <th className="detail">
                                            {
                                                privatePolicy[locale]
                                                    .text_table_four
                                                    .text_head[1]
                                            }
                                        </th>
                                        <th className="process">
                                            {
                                                privatePolicy[locale]
                                                    .text_table_four
                                                    .text_head[2]
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {privatePolicy[
                                        locale
                                    ].text_table_four.text_row.map(
                                        (itemTableFour, indexTableFour) => (
                                            <tr key={indexTableFour}>
                                                <td>
                                                    <p>
                                                        {
                                                            itemTableFour
                                                                .data_type
                                                                .normal_text
                                                        }
                                                    </p>
                                                    {itemTableFour.data_type
                                                        .text_dot && (
                                                        <ul>
                                                            {itemTableFour.data_type.text_dot.map(
                                                                (
                                                                    itemDotFour,
                                                                    indexDotFour
                                                                ) => (
                                                                    <li
                                                                        key={
                                                                            indexDotFour
                                                                        }
                                                                    >
                                                                        {
                                                                            itemDotFour
                                                                        }
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    )}
                                                </td>
                                                <td>
                                                    {itemTableFour.desc.map(
                                                        (
                                                            itemDescFour,
                                                            indexDescFour
                                                        ) => (
                                                            <div
                                                                key={
                                                                    indexDescFour
                                                                }
                                                            >
                                                                <p>
                                                                    {
                                                                        itemDescFour
                                                                    }
                                                                </p>
                                                            </div>
                                                        )
                                                    )}
                                                </td>
                                                <td>
                                                    {itemTableFour.process.map(
                                                        (
                                                            itemProcessFour,
                                                            indexProcessFour
                                                        ) => (
                                                            <div
                                                                key={
                                                                    indexProcessFour
                                                                }
                                                            >
                                                                <p>
                                                                    {
                                                                        itemProcessFour
                                                                    }
                                                                </p>
                                                            </div>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_five}</p>
                        </div>
                        <div className="text-detail">
                            <p>
                                {privatePolicy[locale].text_topic_five_detail}
                            </p>
                        </div>
                        <div className="text">
                            <ul>
                                {privatePolicy[locale].text_dot_five.map(
                                    (itemDotFive, indexDotFive) => (
                                        <li key={indexDotFive}>
                                            {itemDotFive}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_six}</p>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_six_one}</p>
                        </div>
                        <div className="text-detail-six">
                            <ul>
                                {privatePolicy[locale].text_six_one_dot.map(
                                    (itemSix, indexSix) => (
                                        <li key={indexSix}>{itemSix}</li>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_six_two}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_six_three}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_seven}</p>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_seven_one}</p>
                        </div>
                        <div className="text-detail">
                            <ul>
                                {privatePolicy[locale].text_dot_seven.map(
                                    (itemDotSeven, indexDotSeven) => (
                                        <li key={indexDotSeven}>
                                            {itemDotSeven}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_seven_two}</p>
                        </div>
                        <div className="text">
                            <ul>
                                {privatePolicy[locale].text_dot_seven_nd.map(
                                    (itemDotSevenNd, indexDotSevenNd) => (
                                        <li key={indexDotSevenNd}>
                                            {itemDotSevenNd}
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_eight}</p>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_eight_one}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_eight_two}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_nine}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_nine_desc}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_ten}</p>
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_ten_desc}</p>
                        </div>
                        <div className="text-detail">
                            <p>{privatePolicy[locale].text_eleven_detail}</p>
                        </div>
                        <div className="text">
                            {privatePolicy[locale].text_eleven_desc.map(
                                (itemEleven, indexEleven) => (
                                    <div
                                        key={indexEleven}
                                        className="text-detail"
                                    >
                                        <p>{itemEleven}</p>
                                    </div>
                                )
                            )}
                        </div>
                        <div className="text">
                            <p>{privatePolicy[locale].text_topic_twelve}</p>
                        </div>
                        <div className="text-bottom">
                            {privatePolicy[locale].text_twelve_content.map(
                                (itemTwelve, indexTwelve) => (
                                    <div key={indexTwelve}>
                                        <p>{itemTwelve}</p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </ClientLayout>
    );
};

export const getStaticProps = async (ctx) => {
    const { locale } = ctx;
    const meta = {
        title: textConfig[locale]?.title_privacy_policy,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Privacy Policy Page',
        image: 'main-pic.jpeg',
    };

    return {
        props: { meta, locale },
    };
};

export default MetaHeader(contentFooter);
